import type {
  AccountSiteStaffMemberListModel,
  AccountSiteStaffMemberModel,
} from './account-site-staff-member.type.ts';
import type { Address } from './address.type.ts';
import type { LookupModel } from './lookup.type.ts';
import type { SelectableUserListModel, UserListModel, UserModel } from './user-type.ts';

export interface StaffMemberModel extends UserModel {
  notes: string;
  addressId?: number;
  otherDietaryPreference?: string;
  otherDietaryRestriction?: string;
  dietaryPreferences: LookupModel[];
  dietaryRestrictions: LookupModel[];
  staffCredentials: LookupModel[];
  address?: Address;
  foodNotes?: string;
  accountSiteStaffMembers: AccountSiteStaffMemberListModel[];
  canDelete?: boolean;
  canReleaseEmail?: boolean;
  cannotDeleteReasons?: string[];
}

export interface StaffRoleModel {
  id: StaffRoleEnum;
  description: string;
  definition: string;
}

export enum StaffRoleEnum {
  User = 1,
  Manager = 2,
  SiteAdministrator = 3,
  OrganizationAdministrator = 4,
}

export interface StaffMemberListModel extends UserListModel {
  accountName?: string;
  position?: string;
  dietaryPreferences?: string[];
  dietaryRestrictions?: string[];
  foodNotes?: string;
  otherDietaryPreference?: string;
  otherDietaryRestriction?: string;
  accountSiteStaffMembers: AccountSiteStaffMemberListModel[];
}

export interface SelectableStaffMemberListModel
  extends StaffMemberListModel,
    SelectableUserListModel {}

export interface NewStaffMemberModel {
  staffMember?: StaffMemberModel;
  accountSiteStaffMember?: AccountSiteStaffMemberModel;
}

export interface EditStaffMemberModel {
  staffMember: StaffMemberModel;
}
